import { render } from "./ConnectboxBlock.vue?vue&type=template&id=156fc195"
import script from "./ConnectboxBlock.vue?vue&type=script&lang=js"
export * from "./ConnectboxBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/ConnectboxBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "156fc195"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('156fc195', __exports__)) {
    api.reload('156fc195', __exports__)
  }
  
  module.hot.accept("./ConnectboxBlock.vue?vue&type=template&id=156fc195", () => {
    api.rerender('156fc195', render)
  })

}


export default __exports__